"use client";

import { useState, type PropsWithChildren } from "react";
import React from "react";
import { twMerge } from "tailwind-merge";

import { getSearchURL } from "@/globals";
import { TYPO_STYLES } from "@/styles/typography";
import { LinkView } from "@/views/link.view";

type SearchModuleCategoryItemProps = {
    active: boolean;
    anchor: string;
    fullPath: string | undefined;
    title: string;
};

export const SearchModuleCategoryItemView = ({
    title,
    fullPath,
    children,
    active,
    anchor,
}: PropsWithChildren<SearchModuleCategoryItemProps>) => {
    const [open, setOpen] = useState(active);

    const handleToggle = () => {
        setOpen(!open);
    };

    const hasNestedChildren = React.Children.toArray(children).some((child) =>
        React.isValidElement(child),
    );

    if (hasNestedChildren) {
        return (
            <li>
                <button
                    onClick={handleToggle}
                    className={twMerge(
                        TYPO_STYLES.bodyExtraBold14(),
                        `${open ? "opened-menu bg-grey3" : "closed-menu bg-white"}`,
                    )}
                >
                    {title}
                </button>

                {open && (
                    <ul>
                        <LinkView
                            href={getSearchURL(fullPath) + "#" + anchor}
                            className={TYPO_STYLES.bodyNormal14()}
                            prefetch={false}
                        >
                            Übersicht
                        </LinkView>
                        {children}
                    </ul>
                )}
            </li>
        );
    } else
        return (
            <li>
                <LinkView
                    href={getSearchURL(fullPath) + "#" + anchor}
                    className={TYPO_STYLES.bodyNormal14()}
                    prefetch={false}
                >
                    {title}
                </LinkView>
            </li>
        );
};
